import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalId: String
  }

  handleSubmit(event) {
    const response = event.detail.fetchResponse
    
    if (response.response.redirected) {
      // If there's a redirect, follow it
      window.location.href = response.response.url
    } else if (response.succeeded) {
      // If successful but no redirect, close the modal
      document.getElementById(this.modalIdValue).close()
    }
  }
} 